import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';
export const filterOOIInnerElementsForEditText = _ref => {
  let {
    innerElements,
    settingsParams
  } = _ref;
  return (innerElements ?? []).flatMap(innerElement => {
    var _innerElement$element, _element$elementParam;
    const element = {
      ...innerElement,
      elementParams: (_innerElement$element = innerElement.elementParams) == null ? void 0 : _innerElement$element.filter(elementParam => {
        var _itemByKey$metadata;
        const itemByKey = settingsParams[elementParam.key];
        return (itemByKey == null || (_itemByKey$metadata = itemByKey.metadata) == null ? void 0 : _itemByKey$metadata.type) === DataType.text;
      })
    };
    return (_element$elementParam = element.elementParams) != null && _element$elementParam.length ? element : [];
  });
};
//# sourceMappingURL=filterOOIInnerElemntsForEditText.js.map